const classtypeAndTime = {
    state: {
        addClasstypeAndTimeDialog: {
            title: '新增班级类型与课程时间信息',
            type: 'add'
        }
    },
    getters: {
        addClasstypeAndTimeDialog: state => state.addClasstypeAndTimeDialog,
    },
    mutations: {
        SET_CLASSTYPE_AND_TIME_DIALOG_TITLE: (state, type) => {
            if (type === 'add') {
                state.addClasstypeAndTimeDialog.title = '新增班级类型与课程时间信息'
                state.addClasstypeAndTimeDialog.type = 'add'
            } else {
                state.addClasstypeAndTimeDialog.title = '编辑班级类型与课程时间信息'
                state.addClasstypeAndTimeDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default classtypeAndTime